import React, { useEffect, useState } from "react";
import { fetchReportShelterOccupancy } from "../../../services/httpClient";
import { SingleCardMetric } from "../ui/SingleCardMetric";

interface ShelterOccupancyPercentageMetricState {
  data?: any[];
}

export const ShelterOccupancyPercentageMetric = ({ data }: ShelterOccupancyPercentageMetricState) => {
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [percent, setPercent] = useState<string>();

  useEffect(() => {
    const fetchData = async () => {
      if (data) {
        const occupied = data.filter((item: any) => item.occupant_id !== null).length;
        const percentage = ((occupied / data.length) * 100).toFixed(1);
        setPercent(percentage.toString());
        setIsLoading(false);
      } else {
        await getOccupancyData();
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const getOccupancyData = async () => {
    await fetchReportShelterOccupancy()
      .then((res: any) => {
        const data = res[0].data;
        const occupied = data.filter((item: any) => item.occupant_id !== null).length;
        const percentage = ((occupied / data.length) * 100).toFixed(1);
        setPercent(percentage.toString());
      })
      .catch((err: any) => {
        console.log(err);
      });
  };

  return <SingleCardMetric title={"Occupancy %"} total={percent} isLoading={isLoading} />;
};
